module.exports = __webpack_public_path__ + "img/n.eb4b16b5.jpg";